import React from 'react';
import PropTypes from 'prop-types';
/* styles */
import './avatar.scss';
import NoImage from '../no-image';
import {warning} from '../../../helpers/notifications';

const supportedFileTypes = ['image/jpeg', 'image/png'];

class Avatar extends React.PureComponent {
  getBase64 = (file) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      this.props.handleImageUpload(
        `data:image/png;base64, ${reader.result.substring(reader.result.indexOf(',') + 1)}`,
        file.name
      );
    };
    reader.onerror = (error) => {
      throw new Error(error);
    };
  };

  uploadImage = () => {
    if (this.props.isEditable) {
      this.fileInput.click();
    }
  };

  handleImageUpload = (event) => {
    if (!event.target.files[0]) {
      return;
    }
    if (!supportedFileTypes.find((type) => type === event.target.files[0].type)) {
      warning({message: 'JPEG and PNG files allowed'});
      event.target.value = null;
      return;
    }
    if (event.target.files[0].size > 10 * 2 ** 20) {
      warning({message: 'File too large. Max file size is 10MB.'});
      event.target.value = null;
      return;
    }
    this.getBase64(event.target.files[0]);
    event.target.value = null;
  };

  getAvatar = () => {
    if (this.props.isEmpty) {
      return <NoImage size={this.props.size === 'lg' ? 100 : 50} />;
    }
    if (this.props.imageSrc) {
      if (this.props.isEditable) {
        return (
          <div className="glu-avatar__container">
            <div className="glu-avatar__overlay" />
            <div className="g-icon g-icon-photo_upload" />
            <img className="glu-avatar__placeholder" src={this.props.imageSrc} alt="" />
          </div>
        );
      }

      return <img className="glu-avatar__placeholder" src={this.props.imageSrc} alt="" />;
    }

    return (
      <div className="glu-avatar__placeholder-upload">
        <div className="g-icon g-icon-photo_upload" />
      </div>
    );
  };

  saveRef = (c) => {
    this.fileInput = c;
  };

  render() {
    let avatarClassName = 'glu-avatar';
    avatarClassName += ` glu-avatar--${this.props.size}`;
    if (this.props.className) {
      avatarClassName += ` ${this.props.className}`;
    }
    if (this.props.isEditable) {
      avatarClassName += ' glu-avatar__placeholder--editable';
    }
    return (
      <div className={avatarClassName} onClick={this.uploadImage}>
        <input
          type="file"
          disabled={!this.props.isEditable}
          className="glu-avatar__editable-input"
          ref={this.saveRef}
          onChange={this.handleImageUpload}
        />
        {this.getAvatar()}
      </div>
    );
  }
}

Avatar.propTypes = {
  className: PropTypes.string,
  handleImageUpload: PropTypes.func,
  isEditable: PropTypes.bool,
  isEmpty: PropTypes.bool,
  imageSrc: PropTypes.string,
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
};

Avatar.defaultProps = {
  className: '',
  handleImageUpload: undefined,
  isEditable: false,
  isEmpty: false,
  imageSrc: '',
  size: 'sm',
};

export default Avatar;
